import { render, staticRenderFns } from "./DialogAddImagenesInfraestructura.vue?vue&type=template&id=6b544a1e&scoped=true"
import script from "./DialogAddImagenesInfraestructura.vue?vue&type=script&lang=js"
export * from "./DialogAddImagenesInfraestructura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b544a1e",
  null
  
)

export default component.exports